import React from "react";

export default function HomeIcon({ color = "#52E8CD" }) {
	return (
		<svg
			width={48}
			height={48}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_6427_65035)">
				<g clipPath="url(#clip1_6427_65035)">
					<path
						d="M31.2685 20.1505L29.3485 16.9505C29.2916 16.8559 29.2112 16.7775 29.1151 16.7231C29.019 16.6688 28.9104 16.6402 28.8 16.6401H18.56C18.4496 16.6402 18.341 16.6688 18.2449 16.7231C18.1488 16.7775 18.0684 16.8559 18.0115 16.9505L16.0915 20.1505C16.0317 20.2501 16 20.364 16 20.4801C15.9988 21.1576 16.2667 21.8078 16.7447 22.2878C17.2226 22.7678 17.8717 23.0384 18.5491 23.0401H18.5542C19.1864 23.0417 19.7965 22.8079 20.2656 22.3841C20.7333 22.8069 21.3414 23.0409 21.9718 23.0409C22.6023 23.0409 23.2103 22.8069 23.6781 22.3841C24.146 22.8078 24.7547 23.0424 25.3859 23.0424C26.0171 23.0424 26.6258 22.8078 27.0938 22.3841C27.4611 22.7155 27.9167 22.9331 28.4054 23.0105C28.894 23.088 29.3946 23.0218 29.8464 22.8202C30.2981 22.6186 30.6817 22.2901 30.9504 21.8747C31.219 21.4593 31.3614 20.9749 31.36 20.4801C31.36 20.364 31.3283 20.2501 31.2685 20.1505Z"
						fill={color}
					/>
					<path
						d="M28.8102 24.3204C28.2152 24.3208 27.6283 24.1832 27.0956 23.9185L27.086 23.9229C26.6363 24.1472 26.1467 24.2801 25.6454 24.3142C25.144 24.3482 24.6409 24.2827 24.165 24.1213C23.9986 24.0654 23.8361 23.9982 23.6786 23.9204L23.6716 23.9236C23.2221 24.1479 22.7325 24.2809 22.2312 24.3149C21.73 24.3488 21.227 24.283 20.7513 24.1213C20.585 24.0654 20.4227 23.9982 20.2655 23.9204C19.7337 24.1844 19.1479 24.3214 18.5542 24.3204C18.3415 24.3183 18.1294 24.2991 17.9199 24.2628V30.7204C17.9199 30.8901 17.9874 31.0529 18.1074 31.1729C18.2274 31.2929 18.3902 31.3604 18.5599 31.3604H22.3999V27.5204H24.9599V31.3604H28.7999C28.9697 31.3604 29.1324 31.2929 29.2525 31.1729C29.3725 31.0529 29.4399 30.8901 29.4399 30.7204V24.2602C29.232 24.2975 29.0214 24.3176 28.8102 24.3204Z"
						fill={color}
					/>
				</g>
			</g>
			<rect
				x="1"
				y="1"
				width="46"
				height="46"
				rx="3"
				stroke={color}
				strokeWidth="2"
			/>
			<defs>
				<clipPath id="clip0_6427_65035">
					<rect
						width="15.36"
						height="15.36"
						fill="white"
						transform="translate(16 16)"
					/>
				</clipPath>
				<clipPath id="clip1_6427_65035">
					<rect
						width="15.36"
						height="15.36"
						fill="white"
						transform="translate(16 16)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
